<template>
    <aside
        class="nk-sidebar nk-sidebar-fixed sip-sidebar"
        :class="{ 'nk-sidebar-active': isOpen }"
        id="MainSideBarRightMenu"
        data-content="sidebarMenu"
        aria-label="Primary navigation"
    >
        <div class="nk-sidebar-element nk-sidebar-head sip-sidebar__head">
            <router-link to="/" class="sip-brand" @click.native="$emit('close-sidebar')">
                <span class="sip-brand__mark">
                    <img
                        v-if="logoUrl && !logoError"
                        :src="logoUrl"
                        alt=""
                        class="sip-brand__logo"
                        @error="logoError = true"
                    />
                    <template v-else>S</template>
                </span>
                <span class="sip-brand__copy">
                    <strong>Sipinor</strong>
                    <small class="sip-brand__badge">Admin</small>
                </span>
            </router-link>
            <a
                href="#"
                class="sip-sidebar__close d-xl-none"
                role="button"
                aria-controls="MainSideBarRightMenu"
                aria-label="Close menu"
                @click.prevent="$emit('close-sidebar')"
            >
                <admin-icon name="close" aria-hidden="true"></admin-icon>
            </a>
        </div>

        <div class="nk-sidebar-element sip-sidebar__body">
            <div class="nk-sidebar-content">
                <nav class="nk-sidebar-menu sip-sidebar-nav">
                    <div
                        v-for="group in navGroups"
                        :key="group.key"
                        class="sip-sidebar-nav__group"
                    >
                        <div class="sip-sidebar-nav__label">{{ group.label }}</div>
                        <ul class="nk-menu sip-sidebar-nav__list">
                            <li
                                v-for="item in group.items"
                                :key="item.path"
                                class="nk-menu-item"
                            >
                                <router-link
                                    :to="item.path"
                                    class="nk-menu-link sip-sidebar-nav__item"
                                    :class="{ 'router-link-active is-active': isActive(item) }"
                                    :exact="item.exact"
                                    @click.native="$emit('close-sidebar')"
                                >
                                    <span class="sip-sidebar-nav__icon" aria-hidden="true">
                                        <admin-icon :name="item.icon"></admin-icon>
                                    </span>
                                    <span class="sip-sidebar-nav__title">{{ item.title }}</span>
                                    <small
                                        v-if="navMetric(item.metric)"
                                        class="sip-sidebar-nav__meta sip-sidebar-nav__meta--count"
                                    >{{ navMetric(item.metric) }}</small>
                                </router-link>
                            </li>
                        </ul>
                    </div>
                </nav>
            </div>
        </div>

        <div class="sip-sidebar__foot">
            <div v-if="hasPermission('list-instance')" class="sip-sidebar-status">
                <div class="sip-sidebar-status__row">
                    <span class="sip-sidebar-status__live">
                        <i aria-hidden="true"></i>
                        {{ instanceStats.running }} live
                    </span>
                    <span>{{ instanceStats.expired }} expired</span>
                </div>
            </div>
            <div class="sip-sidebar-user">
                <span class="sip-sidebar-user__avatar" aria-hidden="true">{{ userInitials }}</span>
                <span class="sip-sidebar-user__copy">
                    <span class="sip-sidebar-user__name">{{ userFullName }}</span>
                    <span class="sip-sidebar-user__email">{{ userEmail }}</span>
                </span>
            </div>
        </div>
    </aside>
</template>

<script>
    import { groupAdminMenuItems, isAdminNavActive } from './admin-menu.js'

    export default {
        props: {
            isOpen: {
                type: Boolean,
                default: false,
            },
            navItems: {
                type: Array,
                default() {
                    return [];
                },
            },
            navMetrics: {
                type: Object,
                default() {
                    return {};
                },
            },
            logoUrl: {
                type: String,
                default: '',
            },
            instanceStats: {
                type: Object,
                default() {
                    return {
                        running: 0,
                        expired: 0,
                    };
                },
            },
        },
        data() {
            return {
                logoError: false,
            };
        },
        watch: {
            logoUrl() {
                this.logoError = false;
            },
        },
        computed: {
            navGroups() {
                return groupAdminMenuItems(this.navItems);
            },
            userFullName() {
                const n = (helper.getAuthUser('full_name') || '').trim();
                return n || this.trans('user.profile');
            },
            userEmail() {
                return helper.getAuthUser('email') || '';
            },
            userInitials() {
                const parts = this.userFullName.split(/\s+/).filter(Boolean);
                if (!parts.length) {
                    return 'U';
                }
                if (parts.length === 1) {
                    return parts[0].slice(0, 2).toUpperCase();
                }
                return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
            },
        },
        methods: {
            isActive(item) {
                return isAdminNavActive(this.$route.path, item);
            },
            hasPermission(permission) {
                return helper.hasPermission(permission);
            },
            navMetric(metric) {
                if (!metric) {
                    return '';
                }
                const value = this.navMetrics[metric];
                return value ? value : '';
            },
        },
    };
</script>
